import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/control-auth'

declare global {
    // eslint-disable-next-line vars-on-top
    var ControlAuthApiClient: Client<paths>
    // eslint-disable-next-line vars-on-top
    var getRefreshToken: () => string | null
}

export const refresh = async (refresh_token: string) => {
    const { error } = await globalThis.ControlAuthApiClient.POST(
        '/refresh', {
            body: {
                refresh_token,
            },
        },
    )
    if (error) {
        return false
    }
    return true
}

export const getAuthInfo = async () => {
    const { data, error } = await globalThis.ControlAuthApiClient.GET(
        '/info',
    )
    if (error) {
        throw error
    }
    return { user: data.user, sessionId: data.session_id }
}

export const revoke = async () => {
    const token = await globalThis.getRefreshToken() || ''
    const { error } = await globalThis.ControlAuthApiClient.POST(
        '/revoke', {
            body: {
                token,
            },
        },
    )
    if (error) {
        throw error
    }
    return true
}
